import axiosClient from './axiosClient';
import { cachedRequest } from './requestCache';

export const fetchHighlights = async () =>
    cachedRequest('highlights:all', async () => {
        const response = await axiosClient.get('/v1/youtube-videos');
        if (response.data && response.data.success) {
            return response.data.data;
        }
        throw new Error(response.data.errors || 'Failed to fetch highlights');
    });

export const fetchGameHighlights = async () =>
    cachedRequest('highlights:games', async () => {
        const response = await axiosClient.get('/v1/youtube-videos/games');
        if (response.data && response.data.success) {
            return response.data.data;
        }
        throw new Error(response.data.errors || 'Failed to fetch game highlights');
    });


export const fetchGameVideos = async (gameId) => {
    try {
        const response = await axiosClient.post('/v1/youtube-videos/game-videos', { gameId });
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch game videos');
        }
    } catch (error) {
        throw error;
    }
};